import { render, staticRenderFns } from "./NavigationMobile.vue?vue&type=template&id=a2061074"
import script from "./NavigationMobile.vue?vue&type=script&lang=ts"
export * from "./NavigationMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavigationLinkByDesign: require('/codebuild/output/src1993466134/src/acredo-website/components/navigation/NavigationLinkByDesign.vue').default,NavigationLinkText: require('/codebuild/output/src1993466134/src/acredo-website/components/navigation/NavigationLinkText.vue').default,CountrySwitcher: require('/codebuild/output/src1993466134/src/acredo-website/components/countrySwitcher.vue').default})
